<template>
  <div>
    <b-alert v-model="hasUnknownError" variant="danger" v-if="hasUnknownError" dismissible>
      {{ unknownErrorMessage }}
    </b-alert>
    <b-alert v-model="hasError" variant="danger" v-else-if="hasError" dismissible>
      <h4 class="alert-heading">Die Einladung konnte nicht akzeptiert werden.</h4>
      {{ errorMessage }}
    </b-alert>
    <b-alert show variant="success" dismissible v-else-if="isSucceded && !signationInvitation">
      <h4 class="alert-heading">Einladung akzeptiert</h4>
      <p>
        Die Einladung wurde erfolgreich angenommen und Ihrer Gesuchsliste hinzugefügt.
      </p>
    </b-alert>
    <b-alert show variant="success" dismissible v-else-if="isSucceded && signationInvitation">
      <h4 class="alert-heading">Einladung zum Signieren akzeptiert</h4>
      <p class="mb-1">
        Zum Signieren das Gesuch öffnen und den Button signieren drücken:<br>
        <router-link :to="{ name: 'application-detail', params: { applicationId: acceptedGesuchId }}">Gesuchdetail öffnen</router-link>
      </p>
    </b-alert>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data: () => ({
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      acceptedGesuchId: null,
      signationInvitation: false
    }),
    created () {
      if (this.inviteCode) {
        this.acceptInvite(this.inviteCode)
      }
    },
    methods: {
      acceptInvite (inviteCode) {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('permission/PERMISSION_INVITE_ACCEPT', inviteCode).then(res => {
          const { data, errors } = res
          const { ok, gesuchId, inviteSignature } = data.gesuchPermissionInviteAccept

          if (errors || !ok) {
            this.hasError = true
            this.errorMessage = 'Beim akzeptieren des Gesuchs ist ein Fehler aufgetreten.'
            return
          }

          if (inviteSignature === true) {
            this.signationInvitation = true
            this.acceptedGesuchId = gesuchId
          }

          this.$store.dispatch('application/GET_MY_APPLICATIONS')
          this.$store.dispatch('draft/GET_MY_DRAFTS')

          this.isSucceded = true
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    computed: {
      ...mapState({
        inviteCode: state => state.permission.inviteCode
      })
    }
  }
</script>

<style>

</style>
